import styled, { css } from 'styled-components';
import { Icon } from '@usealloy/component-library';
import type { NodeState } from 'flow/service/graph';

export const StyledCaretIcon = styled(Icon)`
  height: var(--cl-space-6);
  width: var(--cl-space-6);
`;

export const StyledSizeBadge = styled.div<{ isHovered: boolean }>`
&&& {
    display: flex;
    align-items: center;
    background-color: ${({ isHovered }) => (
    isHovered ? 'var(--cl-juicyBlue-300);' : 'var(--cl-juicyBlue-200);'
  )}
    color: ${({ isHovered }) => (
    isHovered ? 'var(--cl-juicyBlue-600);' : 'var(--cl-juicyBlue-500);'
  )}
    border-radius: 50px;
    float: right;
    font-size: var(--cl-font-size-2);
    font-weight: bold;
    height: var(--cl-space-5);
    justify-content: center;
    padding: var(--cl-space-2);
    width: fit-content;
    margin: var(--cl-space-1);
}`;

/* renders the little "hat" that juts above folder nodes */
export const StyledFolderHat = css<{ nodeState: NodeState }>`
  &::before {
        background-color: ${({ nodeState }) => (
    (nodeState === 'hovered' || nodeState === 'focused-hovered')
      ? 'var(--cl-juicyBlue-200)'
      : 'var(--cl-juicyBlue-100)'
  )};
        content: '';
        display: block;
        height: var(--cl-space-5);
        width: 45px;
        position: absolute;
        top: -8px;
        left: 0px;
        border-radius: var(--cl-space-2) var(--cl-space-4);
        z-index: -1;
      }
`;
